import React from 'react';
import { Button } from "@/components/ui/button";

export function Experience() {
  return (
    <section id="experiences" className="py-20 bg-primary text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" 
           style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)', backgroundSize: '40px 40px' }}>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-block px-4 py-1 rounded-full border border-white/20 bg-white/5 text-secondary text-sm font-medium">
              Authentic Experiences
            </div>
            <h2 className="text-4xl md:text-6xl font-serif font-bold leading-tight">
              Immerse Yourself in <span className="text-secondary">Culture & Nature</span>
            </h2>
            <p className="text-white/80 text-lg leading-relaxed">
              Sri Lanka is not just a destination; it's a feeling. From the spicy aroma of our cuisine to the gentle giant elephants of Yala, every moment is a story waiting to be told.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
              {[
                { title: "Wildlife Safari", desc: "Spot leopards and elephants in Yala" },
                { title: "Tea Tasting", desc: "Sip world-famous Ceylon tea in the hills" },
                { title: "Surfing", desc: "Catch waves at Arugam Bay" },
                { title: "Ayurveda", desc: "Rejuvenate with ancient healing" }
              ].map((item, idx) => (
                <div key={idx} className="flex gap-4 items-start">
                  <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center text-secondary text-xl font-serif font-bold shrink-0">
                    {idx + 1}
                  </div>
                  <div>
                    <h4 className="text-xl font-serif font-bold mb-1">{item.title}</h4>
                    <p className="text-white/60 text-sm">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            
            <Button size="lg" className="bg-secondary text-primary hover:bg-secondary/90 mt-8 rounded-full px-8 font-bold">
              Plan Your Experience
            </Button>
          </div>

          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4 mt-12">
                <img 
                  src="https://images.unsplash.com/photo-1705936981588-a4192f66fcfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxTcmklMjBMYW5rYSUyMGVsZXBoYW50cyUyMFlhbGF8ZW58MHx8fHwxNzYzODM3OTgzfDA&ixlib=rb-4.1.0&q=85" 
                  alt="Elephants" 
                  className="rounded-2xl shadow-2xl w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
                />
                <img 
                  src="https://images.unsplash.com/photo-1535032756890-c4d0a4dbfd06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxTcmklMjBMYW5rYW4lMjBmb29kJTIwc3BpY2VzfGVufDB8fHx8MTc2MzgzNzk4OXww&ixlib=rb-4.1.0&q=85" 
                  alt="Spices" 
                  className="rounded-2xl shadow-2xl w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="space-y-4">
                <img 
                  src="https://images.unsplash.com/photo-1737008233497-e68685c8142f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxLYW5keSUyMFRlbXBsZSUyMFRvb3RofGVufDB8fHx8MTc2MzgzNzk2OXww&ixlib=rb-4.1.0&q=85" 
                  alt="Kandy Temple" 
                  className="rounded-2xl shadow-2xl w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                />
                <img 
                  src="https://images.unsplash.com/photo-1586511623600-cb6f44f647d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxOdXdhcmElMjBFbGl5YSUyMHRlYSUyMHBsYW50YXRpb258ZW58MHx8fHwxNzYzODM3OTYyfDA&ixlib=rb-4.1.0&q=85" 
                  alt="Tea Plantation" 
                  className="rounded-2xl shadow-2xl w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
            
            {/* Decorative Circle */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] border border-white/10 rounded-full -z-10 animate-spin-slow" />
          </div>
        </div>
      </div>
    </section>
  );
}
